export default __webpack_public_path__ + "static/media/mag_drone3.18e06e95.jpg";